import { getFetcher, putFetcher } from 'api/swr'
import type { LibraryTabDraft, PlatformId } from './types'

export type AvailableCondition = {
  name: string
  scope: string
}

export type FetchLibraryTabConfResult = {
  parameterKey: string
  etag: string
  description?: string
  draft: LibraryTabDraft
  availableConditions: AvailableCondition[]
  isVersion?: boolean
  clonedFromUnversioned?: boolean
}

export type PublishLibraryTabConfResult = {
  etag: string
  parameterKey: string
  warnings: string[]
}

export async function fetchLibraryTabConf(
  platform: PlatformId,
  isVersion = false,
): Promise<FetchLibraryTabConfResult> {
  return getFetcher('/ops-tools/library-tab-conf', {
    platform,
    isVersion: isVersion ? 'true' : 'false',
  }) as Promise<FetchLibraryTabConfResult>
}

export async function publishLibraryTabConf(input: {
  platform: PlatformId
  etag: string
  draft: LibraryTabDraft
  isVersion?: boolean
}): Promise<PublishLibraryTabConfResult> {
  return putFetcher('/ops-tools/library-tab-conf', {
    arg: {
      platform: input.platform,
      etag: input.etag,
      draft: input.draft,
      isVersion: Boolean(input.isVersion),
    },
  }) as Promise<PublishLibraryTabConfResult>
}
